// Vision Component
export default function Vision() {
  return (
    <section className='py-20 bg-gradient-to-r from-gray-900 via-green-900 to-emerald-900 relative overflow-hidden'>
      {/* Enhanced Background Pattern */}
      <div className='absolute inset-0'>
        {/* Geometric shapes */}
        <div className='absolute top-10 right-20 w-32 h-32 bg-gradient-to-br from-green-400/20 to-emerald-400/10 rounded-full animate-pulse'></div>
        <div className='absolute bottom-20 left-10 w-24 h-24 bg-gradient-to-tl from-emerald-400/15 to-teal-400/5 rounded-full animate-pulse'></div>
        <div className='absolute top-1/2 left-1/3 w-16 h-16 bg-gradient-to-r from-green-300/10 to-emerald-300/20 rounded-full animate-pulse'></div>
        
        {/* Additional decorative elements */}
        <div className='absolute top-1/4 left-1/4 w-2 h-2 bg-green-400/30 rounded-full animate-bounce'></div>
        <div className='absolute top-3/4 right-1/4 w-3 h-3 bg-emerald-400/40 rounded-full animate-bounce animation-delay-300'></div>
        <div className='absolute bottom-1/4 right-1/3 w-1 h-1 bg-teal-400/50 rounded-full animate-ping'></div>
        
        {/* Grid pattern overlay */}
        <div className='absolute inset-0 bg-grid-pattern opacity-5'></div>
        
        {/* Flowing lines */}
        <div className='absolute top-0 left-0 w-full h-full'>
          <svg className='w-full h-full opacity-10' viewBox='0 0 100 100' preserveAspectRatio='none'>
            <path d='M0,20 Q25,10 50,20 T100,20' stroke='currentColor' strokeWidth='0.5' fill='none' className='text-green-400'>
              <animate attributeName='d' dur='8s' repeatCount='indefinite' 
                values='M0,20 Q25,10 50,20 T100,20;M0,30 Q25,20 50,30 T100,30;M0,20 Q25,10 50,20 T100,20'/>
            </path>
            <path d='M0,80 Q25,70 50,80 T100,80' stroke='currentColor' strokeWidth='0.5' fill='none' className='text-emerald-400'>
              <animate attributeName='d' dur='10s' repeatCount='indefinite' 
                values='M0,80 Q25,70 50,80 T100,80;M0,70 Q25,80 50,70 T100,70;M0,80 Q25,70 50,80 T100,80'/>
            </path>
          </svg>
        </div>
      </div>
      
      <div className='container mx-auto px-6 relative z-10'>
        <div className='flex items-center gap-12 max-w-7xl mx-auto'>
          {/* Image */}
          <div className='flex-1 hidden lg:block'>
            <div className='relative'>
              <img 
                src='/assets/vision.webp' 
                alt='Our Vision' 
                className='w-full h-96 object-cover rounded-2xl shadow-2xl'
              />
              <div className='absolute inset-0 bg-gradient-to-br from-green-600/30 to-emerald-600/30 rounded-2xl'></div>
            </div>
          </div>
          
          {/* Content */}
          <div className='flex-1'>
            <h2 className='text-4xl md:text-5xl font-bold text-white mb-8 font-comfortaa'>
              Our <span className='text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-emerald-400'>Vision</span> - Trusted Technology Partner
            </h2>
            <div className='w-24 h-1 bg-gradient-to-r from-green-400 to-emerald-400 rounded-full mb-8'></div>
            <p className='text-xl text-gray-200 leading-relaxed font-light'>
              We aspire to be a <span className='font-semibold text-green-400'>trusted companion to society</span> delivering diverse solutions 
              that touch lives, solve real problems, and bring happiness to communities.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}